// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BtnBack_wrapper__1WYPF","backArrow":"BtnBack_backArrow__2Fvwi"};